import { withInstall } from '@xzx-design/utils'
import _Seckbd from './src/seckbd.vue'

export const Seckbd = withInstall(_Seckbd)
export default Seckbd

export * from './src/seckbd'
